import { useEffect } from 'react';
import './ModalShell.css';

// Shared modal chrome (overlay, dialog frame, close button, Esc-to-close).
// Each project defines its own modal component for the inner layout/content;
// that component wraps its custom markup with this shell. Pass `contentClassName`
// to let a specific modal override the shell's background/border (e.g. a fully
// black, borderless look) without affecting other modals.
function ModalShell({ titleId, onClose, children, contentClassName }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Lock background page scroll while any modal is open; scrolling should
  // only happen inside the modal content itself.
  useEffect(() => {
    const { overflow } = document.body.style;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, []);

  return (
    <div className="modal-shell" role="presentation" onMouseDown={onClose}>
      <section
        aria-labelledby={titleId}
        aria-modal="true"
        className={`modal-shell__content${contentClassName ? ` ${contentClassName}` : ''}`}
        onMouseDown={(event) => event.stopPropagation()}
        role="dialog"
      >
        <button className="modal-shell__close" onClick={onClose} type="button" aria-label="Close project details">
          ×
        </button>
        {children}
      </section>
    </div>
  );
}

export default ModalShell;
